import React, { ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import styles from 'styles/pages/Benefits/ShippingLeads/ShippingLeads.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
    return (
        <section className={cn('header')}>
            <div className={cn('container')}>
                <Breadcrumbs
                    mTop={64}
                    mode="light"
                    links={[
                        { title: 'Benefits', href: '/benefits' },
                        { title: 'Shipping Leads', href: '' },
                    ]}
                />
                <div className={cn('header__content')}>
                    <img className={cn('header__star')} src="/images/pages/Benefits/ShippingLeads/header-hero_bg-star.svg" alt="star" />
                    <div className={cn('header__title-box')}>
                        <h1 className={cn('header__title')}>
                            Shipping Leads for Freight Forwarders
                        </h1>
                        <p className={cn('header__title-description')}>
                            <span>Tap into a global network of logistics opportunities. Receive instant shipping requests,</span>
                            <span>bid on them directly, and connect with businesses seeking your</span>
                            <span>services—anytime, anywhere.</span>
                        </p>
                    </div>
                    <div className={cn('header__buttons')}>
                        <Link className={cn('header__button-get-started')} href="/membership">
                            Get Started Today
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default SectionHeader;